import React from "react";
import PropTypes from "prop-types";
import Media from "react-media";
import Icon from "../../../atoms/icon";
import assetify from "@quintype/framework/assetify";
import UserIcon from "../../../../../assets/images/user.png";

import styles from "./styles.m.css";

function UserLogin({ user, vikatanHosts = {} }) {
  if (user) {
    return (
      <div className={styles.user}>
        <Media query="(max-width: 767px)">
          {matches =>
            matches || user ? (
              <img src={assetify(UserIcon)} style={{ width: "20px" }} />
            ) : (
              <span className={styles.login}>Login</span>
            )
          }
        </Media>
        {user && (
          <div className={styles["myaccount-dropdown-wrap"]}>
            <ul className={styles["myaccount-dropdown"]}>
              <li className={styles["myaccount-item"]}>
                <a href={`${vikatanHosts.userProfile}`} className={styles["myaccount-action-item"]}>
                  My account
                </a>
              </li>
              <li className={styles["myaccount-item"]}>
                <a href={`${vikatanHosts.logout}`} className={styles["myaccount-action-item"]}>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <a
        aria-label="User Login"
        href={global.location && `${vikatanHosts.login}?redirect_url=${global.location.href}`}
        className={styles.user}
      >
        <Icon className="hidden-desktop" type={"user"} /> <span className={`hidden-mobile ${styles.login}`}>Login</span>
      </a>
    );
  }
}

UserLogin.propTypes = {
  user: PropTypes.object,
  vikatanHosts: PropTypes.shape({
    login: PropTypes.string,
    subscription: PropTypes.string,
    userProfile: PropTypes.string,
    logout: PropTypes.string
  })
};

export default UserLogin;
